import Chart from 'chart.js';

export class Estadistica {
  public id: number = Math.floor(0);
  public idAsamblea: number;
  public idPregunta: number;
  public totalMiembros: number = Math.floor(0);
  public totalAsistentes: number = Math.floor(0);
  public totalVotos: number = Math.floor(0);
  public tiempoRestante: number = Math.floor(0);
  public porcentajes: ResumenVoto[] = [];
  public estado = 'P';
  public tipoPregunta: number;
  public totalQuorum: number= Math.floor(0);
  public totalCuotas: number= Math.floor(0);
  public totalCuotasAsamblea: number= Math.floor(0);
  public tipoQuorum = "";
}

export class ResumenVoto {
  public voto = '';
  public cantidad: number = Math.floor(0);
  public porcentaje: number = Math.floor(0.0);
  public cuotas: number = Math.floor(0.0);
}

export class EstadisticaCanvas {
  public estadistica: Estadistica;
  public chart: Chart;
}
